module.exports = __webpack_public_path__ + "img/load_white.9ef8d8f1.png";